export default __webpack_public_path__ + "media/star.a635087f.svg";